// locales/index.ts
import { createI18n } from 'vue-i18n'
import zhCN from './lang/zh-CN'
import ja from './lang/ja'

// 智能获取语言偏好（优先级：本地存储 > 浏览器语言）
const savedLang = 'ja'

const i18n = createI18n({
  legacy: false,        // 必须关闭传统模式[1,7](@ref)
  locale: savedLang,    // 初始语言
  fallbackLocale: 'ja',  // 保底语言
  messages: {           // 语言包注册
    'zh-CN': zhCN,
    'ja': ja
  }
})

// 导出语言选项（用于UI组件）
export const LANG_OPTIONS = [
  { label: '简体中文', value: 'zh-CN' },
  { label: '日语', value: 'ja' }
]

export default i18n
